import config from "@/libs/config";
import React from "react";
import { css } from "@emotion/react";
import { Font } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";

type Props = {
  id: string;
};

export const ConnectBoardLoginIdLabel = ({ id }: Props) => {
  const isSpMode = useIsSpMode();

  if (!id) {
    return <></>;
  }

  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p">
          {config.CONNECT_BOARD_DISPLAY_NAME} ID
        </Font>
      </div>
      <div css={inputWrapper}>
        <Font>{id}</Font>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "200px",
  marginRight: "15px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
  paddingTop: "8px",
});
